import React,{PureComponent} from 'react';
import {Switch,Route} from 'react-router-dom'
import {Grid,Cell} from 'react-md'
import Profile from '../pages/Profile'

//Local Imports
import StudentDashboard from '../pages/StudentDashboard'
import SectionEnrollment from '../pages/Settings'
//import Quizes from '../pages/Quizes'
import TakeQuiz from '../pages/TakeQuiz'
import ESComponentWrapper from '../components/ESComponentWrapper'
import TestScore from '../pages/TestScore'
import Tester from '../pages/Tester';
import PracticeCompleted from '../ui/takeQuiz/practiceCompleted'
import testTimerExpired from '../ui/takeQuiz/testTimerExpired'
import TakeTest from '../pages/TakeTest'
import TroubleShooting from '../pages/TroubleShooting'
import About from '../pages/About'
import FAQ from '../pages/FAQ'
import PerfGraphs from '../pages/PerfGraphs'
import QuizNotMapped from '../pages/QuizNotMapped';
//import LoginScreen from '../pages/LoginScreen'
import { AppProperties } from '../common/functions';

//Import CSS
import '../css/ContentPanel.css';
import Dashboard from '../pages/Dashboard/Dashboard';
import PerformanceAnalytics from '../pages/PerformanceAnalytics/PerformanceAnalytics';
import ShowDashboard from '../pages/ShowDashboard';
import SFDashboard from '../SF/SFPages/SFDashboard/SFDashboard';
import SFTakequiz from '../SF/SFPages/SFTakequiz/SFTakequiz';
import SFPreviewQuestion from "../SF/SFPages/SFTakequiz/SFPreviewQuestion"
import SFProfile from '../SF/SFPages/SFProfile/SFProfile';
import SFPerformanceAnalytics from '../SF/SFPages/SFPerformanceAnalytics/SFPerformanceAnalytics';
import SFLogoutPage from '../SF/SFPages/SFLogoutPage';

class ContentPanel extends PureComponent {
    appProperties = AppProperties();
    constructor(props){
        super(props);
    }
    handleRoute = (url) =>
    {
        console.debug("URL",url);
        this.props.history.push(url);
    }

    render(){
     
        console.debug("this.appProperties.currentUserData>>>>", this.appProperties.currentUserData)
        
        if (this.appProperties.currentUserData.isAnonymous) {
            return (
                <Grid className={this.props.className}>
                    <Cell size={12} className='m-0 w-100 h-100'>
                        <Switch>
                            <Route exact path='/' component={SFLogoutPage}/>
                            <Route exact path='/takequiz' component={ESComponentWrapper(SFTakequiz,this.handleRoute,this.props.updateQuizURL)}/>
                            <Route exact path='/PracticeCompleted' component={ESComponentWrapper(PracticeCompleted,this.handleRoute)}/>
                        </Switch>
                    </Cell>
                </Grid>
            )
        }

        return <Grid className={this.props.className}>

        <Cell size={12} className='m-0 w-100 h-100'>
            <Switch>
                {/* {
                    this.appProperties.enableLTI?null:
                    <Route exact path='/' component={ESComponentWrapper(SFDashboard,this.handleRoute)}/>
                } */}
                <Route exact path='/' component={ESComponentWrapper(SFDashboard,this.handleRoute)}/>
                {/* <Route exact path='/' component={ESComponentWrapper(ShowDashboard,this.handleRoute)}/> */}
                <Route exact path='/settings' component={ESComponentWrapper(SectionEnrollment,this.handleRoute)}/>
                {/* <Route exact path='/takequiz/:quizId/:course_id/:section_id/:quiz_name/:quiz_type' component={ESComponentWrapper(TakeQuiz,this.handleRoute,this.props.updateQuizURL)}/> */}
                <Route exact path='/takequiz' component={ESComponentWrapper(SFTakequiz,this.handleRoute,this.props.updateQuizURL)}/>

                {
                    this.appProperties.currentUserData.role != "0" ? //Allow instructor and ADMIN
                    <Route exact path='/previewquestion' component={ESComponentWrapper(SFPreviewQuestion,this.handleRoute,this.props.updateQuizURL)}/> : ""
                }

                {/* <Route exact path='/takequiz2' component={ESComponentWrapper(TakeQuiz,this.handleRoute,this.props.updateQuizURL)}/> */}
                <Route exact path='/Test' component={ESComponentWrapper(Tester,this.handleRoute)}/>
                <Route exact path='/TestScore' component={ESComponentWrapper(TestScore,this.handleRoute)}/>
                <Route exact path='/PracticeCompleted' component={ESComponentWrapper(PracticeCompleted,this.handleRoute)}/>
                <Route exact path='/testTimerExpired' component={ESComponentWrapper(testTimerExpired,this.handleRoute)}/>
                <Route exact path='/takeTest/:quizId/:quiz_name' component={ESComponentWrapper(TakeTest,this.handleRoute)}/>
                <Route exact path='/troubleShooting' component={ESComponentWrapper(TroubleShooting,this.handleRoute)}/>
                <Route exact path='/about' component={ESComponentWrapper(About,this.handleRoute)}/>
                <Route exact path='/FAQ' component={ESComponentWrapper(FAQ,this.handleRoute)}/>
                {
                    this.appProperties.enableLTI?null:
                    <Route exact path='/profile' component={ESComponentWrapper(SFProfile,this.handleRoute)}/>
                }
                
                <Route exact path='/PerfGraphs' component={ESComponentWrapper(PerfGraphs,this.handleRoute)}/>
                <Route exact path='/quizNotMapped/:carmenQuizTitle' component={ESComponentWrapper(QuizNotMapped,this.handleRoute)}/>
                {/* <Route exact path='/dashboard' component={ESComponentWrapper(Dashboard,this.handleRoute)}/> */}
                <Route exact path='/PerfGraphsV2' component={ESComponentWrapper(PerformanceAnalytics,this.handleRoute)}/>
                {/* <Route exact path='/dashboard' component={ESComponentWrapper(SFDashboard,this.handleRoute)}/> */}

                {/* <Route exact path='/takequiz2' component={ESComponentWrapper(SFTakequiz,this.handleRoute)}/> */}
                {/* {this.appProperties && this.appProperties.currentUserData && this.appProperties.currentUserData.role !== "0" ? 
                    <Route exact path='/performanceAnalytics' component={ESComponentWrapper(SFPerformanceAnalytics,this.handleRoute)}/>
                : null} */}
            </Switch>
        </Cell>
   </Grid>
    }
  };

export default ContentPanel;
